import toast from 'react-hot-toast';
import { capitalize } from '../../helpers';

const handleError = response => {
  let errorMessage = '';

  if (!!response) {
    const data = response.data;

    if (typeof data !== 'object') {
      errorMessage = 'An error occurred, please try again';
    } else {
      for (let error of Object.values(data)) {
        errorMessage = `${errorMessage}${
          error !== null || error !== void 0 ? `${error}` : ''
        }`;
      }
    }

    toast.error(capitalize(errorMessage));
  }
};

export default handleError;
